import React from 'react';

function MeDocumentationResponseSuccess() {
	return (
		<>
			<div className="fw-bold">Response: Success (201)</div>

			<div className="alert alert-success mt-3">
				<pre className="mb-0">
					{JSON.stringify({
						id: 'ID12345',
						status: 'filled',
						symbol: 'AAPL',
						action: 'buy',
						quantity: 1,
						price: 123,
					}, null, 2)}
				</pre>
			</div>

			<table className="table table-hover">
				<thead>
					<tr>
						<th scope="col" width="17%">Instruction</th>
						<th scope="col" width="23%">Value</th>
						<th scope="col" width="30%">Examples<span className="d-inline d-lg-none">, Comments</span></th>
						<th scope="col" width="30%" className="d-none d-lg-table-cell">Comments</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>id</td>
						<td><i>string</i></td>
						<td>&quot;ID12345&quot;</td>
						<td className="d-none d-lg-table-cell">Source brokerage order ID</td>
					</tr>
					<tr>
						<td>status</td>
						<td>accepted, filled</td>
						<td>&quot;filled&quot; <div className="d-block d-lg-none mt-3"><small>Extra &quot;draft&quot; value may be returned for test webhooks and calls</small></div></td>
						<td className="d-none d-lg-table-cell">Extra &quot;draft&quot; value may be returned for test webhooks and calls</td>
					</tr>
					<tr className="text-secondary">
						<td>status_description</td>
						<td><i>string</i></td>
						<td>&quot;Well done&quot; <div className="d-block d-lg-none mt-3"><small>Extra order processing details provided by brokerage, if any</small></div></td>
						<td className="d-none d-lg-table-cell">Extra order processing details provided by brokerage, if any</td>
					</tr>
					<tr className="text-secondary">
						<td>price</td>
						<td><i>number</i></td>
						<td>123 <div className="d-block d-lg-none mt-3"><small>Average fill price, if any</small></div></td>
						<td className="d-none d-lg-table-cell">Average fill price, if any</td>
					</tr>
				</tbody>
			</table>
		</>
	);
}

export default MeDocumentationResponseSuccess;
